// client/src/components/auth/profile/FloatingTextarea.js
import React, { useState } from 'react'
import './FloatingComponents.css'

function FloatingTextarea({
  label,
  name,
  value,
  onChange,
  rows = 3,
  required = false,
  placeholder = '',
  disabled = false,
  onDisabledClick,
  ...props
}) {
  const [isFocused, setIsFocused] = useState(false)
  const hasValue = value && value.length > 0
  const isActive = isFocused || hasValue

  return (
    <div
      className={`floating-input-container ${
        disabled ? 'clickable-when-disabled' : ''
      }`}
      onClick={
        disabled && onDisabledClick
          ? (e) => {
              onDisabledClick(e)
            }
          : undefined
      }
      style={disabled ? { cursor: 'pointer' } : {}}
    >
      <textarea
        className={`floating-textarea ${
          required && !hasValue ? 'has-error' : ''
        }`}
        name={name}
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        rows={rows}
        placeholder={isActive ? placeholder : ''}
        disabled={disabled}
        style={disabled ? { pointerEvents: 'none' } : {}}
        {...props}
      />
      <label
        className={`floating-label ${isActive ? 'active' : ''} ${
          required ? 'required' : ''
        }`}
        style={disabled ? { pointerEvents: 'none' } : {}}
      >
        {label}
      </label>
      {value && (
        <div className="character-count">{value.length} characters</div>
      )}
    </div>
  )
}

export default FloatingTextarea
